export default __webpack_public_path__ + "static/media/ic_box.ecd759ec.svg";